import { trendSignals } from "@/mocks/forecast";

export default function NewsTicker() {
  const items = [...trendSignals, ...trendSignals];

  return (
    <div className="w-full border-y border-foreground-950 bg-foreground-950 py-3">
      <div className="flex items-center">
        <span className="z-10 ml-4 flex shrink-0 items-center gap-2 rounded-md bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50 md:ml-6">
          <i className="ri-flashlight-fill" />
          实时快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-10 pl-8">
            {items.map((signal, index) => (
              <span
                key={`${signal.text}-${index}`}
                className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs text-background-200"
              >
                <span className="text-accent-400">{signal.time}</span>
                <span className="h-1 w-1 rounded-full bg-background-500" />
                {signal.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}